import { useQueryClient } from 'react-query'
import { useHistory } from 'react-router-dom'

const useLayoutAction = () => {
  const queryClient = useQueryClient()
  const history = useHistory()

  const logout = () => {
    queryClient.clear()
    localStorage.removeItem('access_token')
    localStorage.removeItem('clientPortalCompany')
    localStorage.removeItem('clientPortalUser')
    history.push('/login')
  }
  return {
    logout,
  }
}

export default useLayoutAction
